(function () {
  'use strict';

  var CART_SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function all(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function one(selector, root) {
    return (root || document).querySelector(selector);
  }

  function parseProduct(panel, selector) {
    var node = one(selector, panel);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function status(panel, message) {
    var node = one('[data-set-cta-status]', panel);
    if (node) node.textContent = message || '';
  }

  function campaignContext() {
    var query = new URLSearchParams(window.location.search);
    return {
      entry_location: 'stayform_inline_cta',
      page_path: window.location.pathname,
      utm_source: query.get('utm_source') || '',
      utm_campaign: query.get('utm_campaign') || '',
    };
  }

  function track(eventName, detail) {
    if (
      window.Shopify
      && window.Shopify.customerPrivacy
      && typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function'
      && !window.Shopify.customerPrivacy.analyticsProcessingAllowed()
    ) return;

    var payload = Object.assign({ event: eventName }, campaignContext(), detail || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('formwynn:' + eventName, { detail: payload }));
  }

  function renderChoices(panel, role, choices, state) {
    var container = one('[data-set-cta-sizes="' + role + '"]', panel);
    if (!container) return;
    container.textContent = '';
    state[role] = null;

    choices.forEach(function (choice) {
      var button = document.createElement('button');
      button.type = 'button';
      button.textContent = choice.size;
      button.dataset.variantId = String(choice.id);
      button.dataset.setCtaSizeRole = role;
      button.setAttribute('aria-pressed', 'false');
      button.disabled = !choice.available;
      button.setAttribute(
        'aria-label',
        choice.available
          ? 'Select ' + role + ' size ' + choice.size
          : choice.size + ' — sold out',
      );
      container.appendChild(button);
    });
  }

  function updateAddButton(panel, state) {
    var button = one('[data-set-cta-add]', panel);
    if (!button) return;
    button.disabled = !(state.bra && state.bottom) || button.dataset.loading === 'true';
  }

  function selectSize(panel, button, state) {
    var role = button.dataset.setCtaSizeRole;
    if ((role !== 'bra' && role !== 'bottom') || button.disabled) return;

    var container = button.parentElement;
    all('[data-set-cta-size-role]', container).forEach(function (other) {
      other.setAttribute('aria-pressed', other === button ? 'true' : 'false');
    });
    state[role] = Number(button.dataset.variantId);
    status(panel, state.bra && state.bottom ? 'Both sizes selected. Ready to add.' : 'Choose both sizes.');
    updateAddButton(panel, state);
  }

  function toggleBottomAngle(button) {
    var sideVisible = button.classList.toggle('is-side');
    var front = one('.fw-home-v2-set-cta__angle-image--front', button);
    var side = one('.fw-home-v2-set-cta__angle-image--side', button);
    button.setAttribute('aria-pressed', sideVisible ? 'true' : 'false');
    button.setAttribute('aria-label', (sideVisible ? 'Show front view of ' : 'Show side view of ') + (button.dataset.productTitle || 'the shorts'));
    if (front) front.setAttribute('aria-hidden', sideVisible ? 'true' : 'false');
    if (side) side.setAttribute('aria-hidden', sideVisible ? 'false' : 'true');
  }

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cartUrl() {
    return window.routes && window.routes.cart_url ? window.routes.cart_url : shopRoot() + 'cart';
  }

  function prepareCartDrawer(cartDrawer, returnFocus) {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-empty');
    if (returnFocus && typeof cartDrawer.setActiveElement === 'function') {
      cartDrawer.setActiveElement(returnFocus);
    }
  }

  function renderCart(result, addButton) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || !result.sections || typeof cartDrawer.renderContents !== 'function') {
      window.location.assign(cartUrl());
      return;
    }

    prepareCartDrawer(cartDrawer, addButton);
    cartDrawer.renderContents(result);
    var drawerInner = one('.drawer__inner', cartDrawer);
    cartDrawer.classList.toggle('is-empty', Boolean(drawerInner && drawerInner.classList.contains('is-empty')));
  }

  async function addSet(panel, state) {
    var addButton = one('[data-set-cta-add]', panel);
    if (!addButton || addButton.dataset.loading === 'true' || !state.bra || !state.bottom) return;

    var core = window.FormwynnSetEventCore;
    if (!core) {
      status(panel, 'Set selection is temporarily unavailable. Please try again.');
      return;
    }

    addButton.dataset.loading = 'true';
    addButton.disabled = true;
    addButton.textContent = 'ADDING…';
    status(panel, 'Adding both pieces to your bag…');

    try {
      var payload = core.createAddPayload(
        { slug: panel.dataset.setSlug },
        state.bra,
        state.bottom,
        window.location.pathname,
      );
      payload.sections = CART_SECTIONS;

      var addUrl = window.routes && window.routes.cart_add_url
        ? window.routes.cart_add_url
        : shopRoot() + 'cart/add.js';
      var response = await fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      });
      var result = await response.json();
      if (!response.ok) {
        throw new Error(result.description || result.message || 'Unable to add the set.');
      }

      track('set_add_to_cart', {
        set_name: panel.dataset.setName,
        bra_product_id: panel.dataset.braProductId,
        bra_variant_id: state.bra,
        bottom_product_id: panel.dataset.bottomProductId,
        bottom_variant_id: state.bottom,
        bra_colour: panel.dataset.braColour,
        bottom_colour: panel.dataset.bottomColour,
      });
      status(panel, 'Set added to your bag.');
      renderCart(result, addButton);
    } catch (error) {
      status(panel, error && error.message ? error.message : 'Something went wrong. Please try again.');
    } finally {
      addButton.dataset.loading = 'false';
      addButton.textContent = panel.dataset.buttonLabel + ' — ' + panel.dataset.buttonPrice;
      updateAddButton(panel, state);
    }
  }

  function initPanel(panel) {
    if (panel.dataset.setCtaBound === 'true') return;
    panel.dataset.setCtaBound = 'true';

    var core = window.FormwynnSetEventCore;
    var state = { bra: null, bottom: null };
    var bra = parseProduct(panel, '[data-set-cta-bra-json]');
    var bottom = parseProduct(panel, '[data-set-cta-bottom-json]');
    var addButton = one('[data-set-cta-add]', panel);

    if (!core || !bra || !bottom || !addButton) {
      status(panel, 'Set selection is temporarily unavailable.');
      return;
    }

    var braChoices = core.buildVariantChoices(bra, panel.dataset.braColour);
    var bottomChoices = core.buildVariantChoices(bottom, panel.dataset.bottomColour);
    renderChoices(panel, 'bra', braChoices, state);
    renderChoices(panel, 'bottom', bottomChoices, state);

    if (!braChoices.length || !bottomChoices.length) {
      status(panel, 'This set is unavailable because its configured colour or sizes could not be matched.');
      return;
    }

    panel.addEventListener('click', function (event) {
      var sizeButton = event.target.closest('[data-set-cta-size-role]');
      if (sizeButton && panel.contains(sizeButton)) {
        selectSize(panel, sizeButton, state);
        return;
      }

      var angleButton = event.target.closest('[data-set-cta-angle-toggle]');
      if (angleButton && panel.contains(angleButton)) {
        toggleBottomAngle(angleButton);
      }
    });
    addButton.addEventListener('click', function () { addSet(panel, state); });
    updateAddButton(panel, state);
  }

  function initAll(root) {
    all('[data-set-cta]', root || document).forEach(initPanel);
  }

  if (window.__FORMWYNN_SET_CTA_TEST_HOOKS__) {
    Object.assign(window.__FORMWYNN_SET_CTA_TEST_HOOKS__, {
      addSet: addSet,
      initPanel: initPanel,
      renderChoices: renderChoices,
      selectSize: selectSize,
      updateAddButton: updateAddButton,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
